export default __webpack_public_path__ + "static/media/in-review.3ecfac70.png";